import React, { useState, useContext, useEffect, useRef } from "react";
import { useHistory } from "react-router-dom";
import $ from "jquery";
//pages & includes
import ManageSidebar from "../ManageSidebar";
import _ from "lodash";
import moment from "moment";
//functions
import {
  _t,
  getCookie,
  modalLoading,
  tableLoading,
  pagination,
  paginationLoading,
  showingData,
  searchedShowingData,
} from "../../../../../functions/Functions";
import { useTranslation } from "react-i18next";

//axios and base url
import axios from "axios";
import { BASE_URL } from "../../../../../BaseUrl";

//3rd party packages
import { Helmet } from "react-helmet";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

//context consumer
import { SettingsContext } from "../../../../../contexts/Settings";
import { MasterContext } from "../../../../../contexts/Master";

const initialValidationErrors = {
  date: false,
  ledger: false,
  amount: false,
  narration: false,
};
const ExpressCrud = () => {
  const [ledgerList, setLedgerList] = useState(null);
  const [validationErrors, setValidationErrors] = useState({
    ...initialValidationErrors,
  });
  const dateRef = useRef(null);
  const ledgerRef = useRef(null);
  const amountRef = useRef(null);
  const narRef = useRef(null);

  const { t } = useTranslation();
  const history = useHistory();
  //getting context values here
  let {
    //common
    loading,
    setLoading,
  } = useContext(SettingsContext);

  let {
    expenseList,
    setExpenseList,
    setPaginatedExpense,
    expenseforSearch,
    setExpenseforSearch,

    //pagination
    dataPaginating,
  } = useContext(MasterContext);

  // States hook here
  useEffect(() => {
    let isActive = true;
    isActive && getLedgerList();
    return () => {
      isActive = false;
    };
  }, []);
  const getLedgerList = () => {
    const ledgerGetUrl = BASE_URL + `/settings/ledger`;
    return axios
      .get(ledgerGetUrl, {
        headers: { Authorization: `Bearer ${getCookie()}` },
      })
      .then((res) => {
        setLedgerList(res.data.data);
      });
  };
  const [refresh, setRefresh] = useState(false);
  useEffect(() => {
    let isActive = true;
    isActive && getRecords();
    return () => (isActive = false);
  }, [refresh]);

  const getRecords = () => {
    const ledgerGetUrl = BASE_URL + `/settings/expense?limit=10&offset=0`;
    return axios
      .get(ledgerGetUrl, {
        headers: { Authorization: `Bearer ${getCookie()}` },
      })
      .then((res) => {
        setExpenseList(res.data.data);
      });
  };
  //new ledger
  let [newExpense, setNewExpense] = useState({
    date: "",
    ledger: null,
    narration: "",
    amount: "",
    edit: false,
    editSlug: null,
    uploading: false,
  });

  //search result
  let [searchExpense, setSearchExpense] = useState({
    list: null,
    searched: false,
  });

  //useEffect == componentDidMount
  useEffect(() => {}, []);

  //set name hook
  const handleSetNewFoodGroup = (e) => {
    let numberCheck = /^[+]?([0-9]+(?:[\.][0-9]*)?|\.[0-9]+)$/;
    setValidationErrors({
      ...validationErrors,
      [e.target.name]: false,
    });
    if (e.target.value.length > 0 && e.target.name == "amount") {
      numberCheck.test(e.target.value) === false
        ? setValidationErrors({
            ...validationErrors,
            amount: "Enter valid amount",
          })
        : setValidationErrors({
            ...validationErrors,
            amount: false,
          });
    }
    setNewExpense({ ...newExpense, [e.target.name]: e.target.value });
  };

  const validateFields = () => {
    let formData = new FormData();
    let error = validationErrors;
    let numberCheck = /^[+]?([0-9]+(?:[\.][0-9]*)?|\.[0-9]+)$/;

    if (_.isEmpty(newExpense.date)) {
      error.date = "Enter date";
      dateRef.current.focus();
      formData = undefined;
    } else {
      error.amount = false;
      formData &&
        formData.append("date", moment(newExpense.date).format("YYYY-MM-DD"));
    }
    if (_.isEmpty(newExpense.ledger)) {
      error.ledger = "Choose ledger";
      ledgerRef.current.focus();
      formData = undefined;
    } else {
      formData && formData.append("ledger_id", newExpense.ledger);
    }
    if (_.isEmpty(newExpense.amount)) {
      error.amount = "Enter amount";
      amountRef.current.focus();
      formData = undefined;
    } else if (numberCheck.test(newExpense.amount) === false) {
      error.amount = "Enter valid amount";
      formData = undefined;

      formData = undefined;
    } else {
      formData && formData.append("amount", newExpense.amount);
    }
    if (_.isEmpty(newExpense.narration)) {
      error.narration = "Enter narration";
      narRef.current.focus();
      formData = undefined;
    } else {
      formData && formData.append("narration", newExpense.narration);
    }
    setValidationErrors({ ...validationErrors, error });
    return formData;
  };

  //Save New Ledger
  const handleSaveNewFoodGroup = (e) => {
    console.log("gggggggggggggggg");
    e.preventDefault();
    const ledgerUrl = BASE_URL + `/settings/expense/create`;
    let formData = validateFields();
    if (!_.isUndefined(formData)) {
      setNewExpense({
        ...newExpense,
        uploading: true,
      });
      return axios
        .post(ledgerUrl, formData, {
          headers: { Authorization: `Bearer ${getCookie()}` },
        })
        .then((res) => {
          console.log(res.data, "sssssssssss");
          setNewExpense({
            date: "",
            ledger: "",
            narration: "",
            edit: false,
            editSlug: null,
            uploading: false,
          });
          // setRefresh(!refresh);
          // setExpenseList(res.data[0]);
          // setExpenseforSearch(res.data[1]);
          // setSearchExpense({
          //   ...searchExpense,
          //   list: res.data[1],
          // });
          // $("#addPaymentType").modal("hide");
          setLoading(false);
          res.data.keyword != "failed"
            ? toast.success(`${_t(t("Expense has been added"))}`, {
                position: "bottom-center",
                autoClose: 1000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                className: "text-center toast-notification",
              })
            : toast.error(`${_t(t("Expense already exists with this name"))}`, {
                position: "bottom-center",
                autoClose: 1000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                className: "text-center toast-notification",
              });
        })
        .catch((error) => {
          console.log(error);
          setLoading(false);
          setNewExpense({
            ...newExpense,
            uploading: false,
          });
        });
    }
  };

  //set edit true & values
  const handleSetEdit = (index) => {
    let paymentType = expenseList[index];
    setNewExpense({
      ...newExpense,
      date: paymentType.date,
      ledger: paymentType.ledger_id,
      narration: paymentType.narration,
      amount: paymentType.amount,
      // input_key: paymentType[0].input_key,
      editSlug: paymentType.expense_id,
      edit: true,
    });
  };

  //update food group
  const handleUpdateFoodGroup = (e) => {
    e.preventDefault();
    setNewExpense({
      ...newExpense,
      uploading: true,
    });
    const ledgerUrl = BASE_URL + `/settings/expense/update`;
    let formData = new FormData();
    formData.append("expense_id", newExpense.editSlug);
    formData.append("date", newExpense.date);
    formData.append("ledger_id", newExpense.ledger);
    formData.append("narration", newExpense.narration);
    formData.append("amount", newExpense.amount);

    return axios
      .post(ledgerUrl, formData, {
        headers: { Authorization: `Bearer ${getCookie()}` },
      })
      .then((res) => {
        setNewExpense({
          date: "",
          ledger: "",
          narration: "",
          edit: false,
          editSlug: null,
          uploading: false,
        });
        // setExpenseList(res.data[0]);
        // setExpenseforSearch(res.data[1]);
        // setSearchExpense({
        //   ...searchExpense,
        //   list: res.data[1],
        // });
        setRefresh(!refresh);
        setLoading(false);
        toast.success(`${_t(t("Expense has been updated"))}`, {
          position: "bottom-center",
          autoClose: 1000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          className: "text-center toast-notification",
        });
      })
      .catch((error) => {
        setLoading(false);
        setNewExpense({
          ...newExpense,
          uploading: false,
        });
        if (error.response.data.errors) {
          if (error.response.data.errors.name) {
            error.response.data.errors.name.forEach((item) => {
              if (item === "A expense already exists with this name") {
                toast.error(
                  `${_t(t("A expense already exists with this name"))}`,
                  {
                    position: "bottom-center",
                    autoClose: 10000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    className: "text-center toast-notification",
                  }
                );
              }
            });
          } else {
            toast.error(`${_t(t("Please try again"))}`, {
              position: "bottom-center",
              autoClose: 10000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              className: "text-center toast-notification",
            });
          }
        }
      });
  };

  //search food group here
  const handleSearch = (e) => {
    let searchInput = e.target.value.toLowerCase();
    if (searchInput.length === 0) {
      setSearchExpense({ ...searchExpense, searched: false });
    } else {
      let searchedList = expenseforSearch.filter((item) => {
        let lowerCaseItemName = item.name.toLowerCase();
        return lowerCaseItemName.includes(searchInput);
      });
      setSearchExpense({
        ...searchExpense,
        list: searchedList,
        searched: true,
      });
    }
  };

  //delete confirmation modal of paymentType
  const handleDeleteConfirmation = (index) => {
    confirmAlert({
      customUI: ({ onClose }) => {
        return (
          <div className="card card-body">
            <h1>{_t(t("Are you sure?"))}</h1>
            <p className="text-center">{_t(t("You want to delete this?"))}</p>
            <div className="d-flex justify-content-center">
              <button
                className="btn btn-primary"
                onClick={() => {
                  handleDeleteFoodGroup(index);
                  onClose();
                }}
              >
                {_t(t("Yes, delete it!"))}
              </button>
              <button className="btn btn-success ml-2 px-3" onClick={onClose}>
                {_t(t("No"))}
              </button>
            </div>
          </div>
        );
      },
    });
  };
  const deleteFields = (index) => {
    let formData = new FormData();
    let ids = [];
    ids.push(expenseList[index].expense_id);
    formData.append("id", JSON.stringify(ids));
    return formData;
  };
  //delete paymentType here
  const handleDeleteFoodGroup = (index) => {
    setLoading(true);
    let formData = deleteFields(index);

    const ledgerUrl = BASE_URL + `/settings/expense/delete`;
    return axios
      .post(ledgerUrl, formData, {
        headers: { Authorization: `Bearer ${getCookie()}` },
      })
      .then((res) => {
        setRefresh(!refresh);
        // setExpenseList(res.data[0]);
        // setExpenseforSearch(res.data[1]);
        // setSearchExpense({
        //   ...searchExpense,
        //   list: res.data[1],
        // });
        setLoading(false);
        toast.success(`${_t(t("Expense has been deleted successfully"))}`, {
          position: "bottom-center",
          autoClose: 10000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          className: "text-center toast-notification",
        });
      })
      .catch(() => {
        setLoading(false);
        toast.error(`${_t(t("Please try again"))}`, {
          position: "bottom-center",
          autoClose: 1000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          className: "text-center toast-notification",
        });
      });
  };

  return (
    <>
      <Helmet>
        <title>{_t(t("Expense List"))}</title>
      </Helmet>

      {/* Add modal */}
      <div className="modal fade" id="addPaymentType" aria-hidden="true">
        <div className="modal-dialog modal-lg">
          <div className="modal-content">
            <div className="modal-header align-items-center">
              <div className="fk-sm-card__content">
                <h5 className="text-capitalize fk-sm-card__title">
                  {!newExpense.edit
                    ? _t(t("Add new expense"))
                    : _t(t("Update expense"))}
                </h5>
              </div>
              <button
                type="button"
                className="btn-close"
                data-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body">
              {/* show form or show saving loading */}
              {newExpense.uploading === false ? (
                <div key="fragment-food-group-1">
                  <form
                    onSubmit={
                      !newExpense.edit
                        ? handleSaveNewFoodGroup
                        : handleUpdateFoodGroup
                    }
                  >
                    <div>
                      <label htmlFor="name" className="form-label">
                        {_t(t("Date"))}{" "}
                        <small className="text-primary">*</small>
                      </label>
                      <input
                        type="date"
                        ref={dateRef}
                        className="form-control"
                        id="date"
                        name="date"
                        placeholder="e.g. Date"
                        value={newExpense.date || ""}
                        // required
                        onChange={handleSetNewFoodGroup}
                      />
                      {validationErrors.date && (
                        <h6
                          style={{
                            fontSize: 10,
                            color: "red",
                            marginTop: 10,
                          }}
                        >
                          {validationErrors.date}
                        </h6>
                      )}
                      <label htmlFor="ledger" className="form-label">
                        {_t(t("Ledger"))}{" "}
                        <small className="text-primary">*</small>
                      </label>
                      {/* <input
                        type="text"
                        className="form-control"
                        id="ledger"
                        name="ledger"
                        placeholder="e.g. Ledger"
                        value={newExpense.ledger || ""}
                        required
                        onChange={handleSetNewFoodGroup}
                      /> */}
                      <select
                        value={newExpense.ledger}
                        ref={ledgerRef}
                        class="form-select"
                        aria-label="Default select example"
                        id="ledger"
                        name="ledger"
                        onChange={(e) => {
                          console.log(e.target.value, "valuee");
                          setValidationErrors({
                            ...validationErrors,
                            ledger: _.isEmpty(e.target.value)
                              ? "Choose ledger"
                              : false,
                          });
                          setNewExpense({
                            ...newExpense,
                            ledger: e.target.value,
                          });
                        }}
                      >
                        <option selected value={""}>
                          e.g. Ledger
                        </option>
                        {ledgerList &&
                          ledgerList.map((ledger, index) => {
                            return (
                              <option value={ledger.ledger_id}>
                                {ledger.ledger_name}
                              </option>
                            );
                          })}
                      </select>
                      {validationErrors.ledger && (
                        <h6
                          style={{
                            fontSize: 10,
                            color: "red",
                            marginTop: 10,
                          }}
                        >
                          {validationErrors.ledger}
                        </h6>
                      )}
                      <label htmlFor="amount" className="form-label">
                        {_t(t("Amount"))}{" "}
                        <small className="text-primary">*</small>
                      </label>
                      <input
                        ref={amountRef}
                        type="number"
                        className="form-control"
                        id="amount"
                        name="amount"
                        placeholder="e.g. Amount"
                        value={newExpense.amount || ""}
                        // required
                        onChange={handleSetNewFoodGroup}
                      />
                      {validationErrors.amount && (
                        <h6
                          style={{
                            fontSize: 10,
                            color: "red",
                            marginTop: 10,
                          }}
                        >
                          {validationErrors.amount}
                        </h6>
                      )}
                      <label htmlFor="narration" className="form-label">
                        {_t(t("Narration"))}{" "}
                        <small className="text-primary">*</small>
                      </label>
                      <input
                        ref={narRef}
                        type="text"
                        className="form-control"
                        id="narration"
                        name="narration"
                        placeholder="e.g. Narration"
                        value={newExpense.narration || ""}
                        // required
                        onChange={handleSetNewFoodGroup}
                      />
                    </div>
                    {validationErrors.narration && (
                      <h6
                        style={{
                          fontSize: 10,
                          color: "red",
                          marginTop: 10,
                        }}
                      >
                        {validationErrors.narration}
                      </h6>
                    )}
                    <div className="mt-4">
                      <div className="row">
                        <div className="col-6">
                          <button
                            type="submit"
                            className="btn btn-success w-100 xsm-text text-uppercase t-width-max"
                          >
                            {!newExpense.edit ? _t(t("Save")) : _t(t("Update"))}
                          </button>
                        </div>
                        <div className="col-6">
                          <button
                            type="button"
                            className="btn btn-primary w-100 xsm-text text-uppercase t-width-max"
                            data-dismiss="modal"
                          >
                            {_t(t("Close"))}
                          </button>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
              ) : (
                <div key="fragment2">
                  <div className="text-center text-primary font-weight-bold text-uppercase">
                    {_t(t("Please wait"))}
                  </div>
                  {modalLoading(3)}
                  <div className="mt-4">
                    <div className="row">
                      <div className="col-6">
                        <button
                          type="button"
                          className="btn btn-success w-100 xsm-text text-uppercase t-width-max"
                          onClick={(e) => {
                            e.preventDefault();
                          }}
                        >
                          {!newExpense.edit ? _t(t("Save")) : _t(t("Update"))}
                        </button>
                      </div>
                      <div className="col-6">
                        <button
                          type="button"
                          className="btn btn-primary w-100 xsm-text text-uppercase t-width-max"
                          data-dismiss="modal"
                        >
                          {_t(t("Close"))}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
      {/* Add modal Ends*/}

      {/* main body */}
      <main id="main" data-simplebar>
        <div className="container">
          <div className="row t-mt-10 gx-2">
            {/* left Sidebar */}
            <div className="col-lg-3 col-xxl-2 t-mb-30 mb-lg-0">
              <ManageSidebar />
            </div>
            {/* left Sidebar ends */}

            {/* Rightbar contents */}
            <div className="col-lg-9 col-xxl-10 t-mb-30 mb-lg-0">
              <div className="t-bg-white">
                <div className="fk-scroll--pos-menu" data-simplebar>
                  <div className="t-pl-15 t-pr-15">
                    {/* Loading effect */}
                    {newExpense.uploading === true || loading === true ? (
                      tableLoading()
                    ) : (
                      <div key="fragment3">
                        {/* next page data spin loading */}
                        <div className={`${dataPaginating && "loading"}`}></div>
                        {/* spin loading ends */}

                        <div className="row gx-2 align-items-center t-pt-15 t-pb-15">
                          <div className="col-md-6 col-lg-5 t-mb-15 mb-md-0">
                            <ul className="t-list fk-breadcrumb">
                              <li className="fk-breadcrumb__list">
                                <span className="t-link fk-breadcrumb__link text-capitalize">
                                  {!searchExpense.searched
                                    ? _t(t("Expense List"))
                                    : _t(t("Search Result"))}
                                </span>
                              </li>
                            </ul>
                          </div>
                          <div className="col-md-6 col-lg-7">
                            <div className="row gx-3 align-items-center">
                              {/* Search group */}
                              <div className="col-md-9 t-mb-15 mb-md-0">
                                <div className="input-group">
                                  <div className="form-file">
                                    <input
                                      type="text"
                                      className="form-control border-0 form-control--light-1 rounded-0"
                                      placeholder={_t(t("Search")) + ".."}
                                      onChange={handleSearch}
                                    />
                                  </div>
                                  <button
                                    className="btn btn-primary"
                                    type="button"
                                  >
                                    <i
                                      className="fa fa-search"
                                      aria-hidden="true"
                                    ></i>
                                  </button>
                                </div>
                              </div>

                              {/* Add group modal trigger button */}
                              <div className="col-md-3 text-md-right">
                                <button
                                  type="button"
                                  className="btn btn-primary xsm-text text-uppercase btn-lg btn-block"
                                  data-toggle="modal"
                                  data-target="#addPaymentType"
                                  onClick={() => {
                                    setNewExpense({
                                      ...newExpense,
                                      edit: false,
                                      uploading: false,
                                      editSlug:null
                                    });
                                  }}
                                >
                                  {_t(t("add new"))}
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                        {/* Table */}
                        <div className="table-responsive">
                          <table className="table table-bordered table-hover min-table-height">
                            <thead className="align-middle">
                              <tr>
                                <th
                                  scope="col"
                                  className="sm-text text-capitalize align-middle text-center border-1 border"
                                >
                                  {_t(t("Date"))}
                                </th>

                                <th
                                  scope="col"
                                  className="sm-text text-capitalize align-middle text-center border-1 border"
                                >
                                  {_t(t("Ledger"))}
                                </th>

                                <th
                                  scope="col"
                                  className="sm-text text-capitalize align-middle text-center border-1 border"
                                >
                                  {_t(t("Narration"))}
                                </th>
                                <th
                                  scope="col"
                                  className="sm-text text-capitalize align-middle text-center border-1 border"
                                >
                                  {_t(t("Amount"))}
                                </th>
                                <th
                                  scope="col"
                                  className="sm-text text-capitalize align-middle text-center border-1 border"
                                >
                                  {_t(t("Action"))}
                                </th>
                              </tr>
                            </thead>
                            <tbody className="align-middle">
                              {/* loop here, logic === !search && haveData && haveDataLegnth > 0*/}
                              {!searchExpense.searched
                                ? [
                                    expenseList && [
                                      expenseList.length === 0 ? (
                                        <tr className="align-middle">
                                          <td
                                            scope="row"
                                            colSpan="6"
                                            className="xsm-text align-middle text-center"
                                          >
                                            {_t(t("No data available"))}
                                          </td>
                                        </tr>
                                      ) : (
                                        expenseList.map((item, index) => {
                                          return (
                                            <tr
                                              className="align-middle"
                                              key={index}
                                            >
                                              {/* <th
                                                scope="row"
                                                className="xsm-text text-capitalize align-middle text-center"
                                              >
                                                {index + 1}
                                                {/* +
                                                  (expenseList.current_page -
                                                    1) *
                                                    expenseList.per_page} */}
                                              {/* </th> */}

                                              <td className="xsm-text text-capitalize align-middle text-center">
                                                {moment(
                                                  item.date,
                                                  "YYYY-MM-DD"
                                                ).format("DD-MM-YYYY")}
                                              </td>
                                              <td className="xsm-text text-capitalize align-middle text-center">
                                                {item.ledger_name}
                                              </td>
                                              <td className="xsm-text text-capitalize align-middle text-center">
                                                {item.narration}
                                              </td>
                                              <td className="xsm-text text-capitalize align-middle text-center">
                                                {item.amount}
                                              </td>
                                              <td className="xsm-text text-capitalize align-middle text-center">
                                                <div className="dropdown">
                                                  <button
                                                    className="btn t-bg-clear t-text-dark--light-40"
                                                    type="button"
                                                    data-toggle="dropdown"
                                                  >
                                                    <i className="fa fa-ellipsis-h"></i>
                                                  </button>
                                                  <div className="dropdown-menu">
                                                    <button
                                                      className="dropdown-item sm-text text-capitalize"
                                                      onClick={() =>
                                                        handleSetEdit(index)
                                                      }
                                                      data-toggle="modal"
                                                      data-target="#addPaymentType"
                                                    >
                                                      <span className="t-mr-8">
                                                        <i className="fa fa-pencil"></i>
                                                      </span>
                                                      {_t(t("Edit"))}
                                                    </button>

                                                    <button
                                                      className="dropdown-item sm-text text-capitalize"
                                                      onClick={() => {
                                                        handleDeleteConfirmation(
                                                          index
                                                        );
                                                      }}
                                                    >
                                                      <span className="t-mr-8">
                                                        <i className="fa fa-trash"></i>
                                                      </span>
                                                      {_t(t("Delete"))}
                                                    </button>
                                                  </div>
                                                </div>
                                              </td>
                                            </tr>
                                          );
                                        })
                                      ),
                                    ],
                                  ]
                                : [
                                    /* searched data, logic === haveData*/
                                    searchExpense && [
                                      searchExpense.list.length === 0 ? (
                                        <tr className="align-middle">
                                          <td
                                            scope="row"
                                            colSpan="6"
                                            className="xsm-text align-middle text-center"
                                          >
                                            {_t(t("No data available"))}
                                          </td>
                                        </tr>
                                      ) : (
                                        searchExpense.list.map(
                                          (item, index) => {
                                            return (
                                              <tr
                                                className="align-middle"
                                                key={index}
                                              >
                                                <th
                                                  scope="row"
                                                  className="xsm-text text-capitalize align-middle text-center"
                                                >
                                                  {index + 1}
                                                  {/* +
                                                    (expenseList.current_page -
                                                      1) *
                                                      expenseList.per_page} */}
                                                </th>

                                                <td className="xsm-text text-capitalize align-middle text-center">
                                                  {item.name}
                                                </td>

                                                <td className="xsm-text text-capitalize align-middle text-center">
                                                  <div className="dropdown">
                                                    <button
                                                      className="btn t-bg-clear t-text-dark--light-40"
                                                      type="button"
                                                      data-toggle="dropdown"
                                                    >
                                                      <i className="fa fa-ellipsis-h"></i>
                                                    </button>
                                                    <div className="dropdown-menu">
                                                      <button
                                                        className="dropdown-item sm-text text-capitalize"
                                                        onClick={() =>
                                                          handleSetEdit(index)
                                                        }
                                                        data-toggle="modal"
                                                        data-target="#addPaymentType"
                                                      >
                                                        <span className="t-mr-8">
                                                          <i className="fa fa-pencil"></i>
                                                        </span>
                                                        {_t(t("Edit"))}
                                                      </button>

                                                      <button
                                                        className="dropdown-item sm-text text-capitalize"
                                                        onClick={() => {
                                                          handleDeleteConfirmation(
                                                            index
                                                          );
                                                        }}
                                                      >
                                                        <span className="t-mr-8">
                                                          <i className="fa fa-trash"></i>
                                                        </span>
                                                        {_t(t("Delete"))}
                                                      </button>
                                                    </div>
                                                  </div>
                                                </td>
                                              </tr>
                                            );
                                          }
                                        )
                                      ),
                                    ],
                                  ]}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>

              {/* pagination loading effect */}
              {newExpense.uploading === true || loading === true
                ? paginationLoading()
                : [
                    // logic === !searched
                    !searchExpense.searched ? (
                      <div key="fragment4">
                        <div className="t-bg-white mt-1 t-pt-5 t-pb-5">
                          <div className="row align-items-center t-pl-15 t-pr-15">
                            <div className="col-md-7 t-mb-15 mb-md-0">
                              {/* pagination function */}
                              {pagination(expenseList, setPaginatedExpense)}
                            </div>
                            <div className="col-md-5">
                              <ul className="t-list d-flex justify-content-md-end align-items-center">
                                <li className="t-list__item">
                                  <span className="d-inline-block sm-text">
                                    {showingData(expenseList)}
                                  </span>
                                </li>
                              </ul>
                            </div>
                          </div>
                        </div>
                      </div>
                    ) : (
                      // if searched
                      <div className="t-bg-white mt-1 t-pt-5 t-pb-5">
                        <div className="row align-items-center t-pl-15 t-pr-15">
                          <div className="col-md-7 t-mb-15 mb-md-0">
                            <ul className="t-list d-flex">
                              <li className="t-list__item no-pagination-style">
                                <button
                                  className="btn btn-primary btn-sm"
                                  onClick={() =>
                                    setSearchExpense({
                                      ...searchExpense,
                                      searched: false,
                                    })
                                  }
                                >
                                  {_t(t("Clear Search"))}
                                </button>
                              </li>
                            </ul>
                          </div>
                          <div className="col-md-5">
                            <ul className="t-list d-flex justify-content-md-end align-items-center">
                              <li className="t-list__item">
                                <span className="d-inline-block sm-text">
                                  {searchedShowingData(
                                    searchExpense,
                                    expenseforSearch
                                  )}
                                </span>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    ),
                  ]}
            </div>
            {/* Rightbar contents end*/}
          </div>
        </div>
      </main>
      {/* main body ends */}
    </>
  );
};

export default ExpressCrud;
